var React = require('react');

function IcArrowPrev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.835 1.8701L10.055 0.100098L0.165039 10.0001L10.065 19.9001L11.835 18.1301L3.70504 10.0001L11.835 1.8701Z","fill":"currentColor"}));
}

IcArrowPrev.defaultProps = {"width":"12","height":"20","viewBox":"0 0 12 20"};

module.exports = IcArrowPrev;

IcArrowPrev.default = IcArrowPrev;
